const messages = {
  en: {
    title: 'Select Product',
    soon: 'Coming Soon!',
    brandfilter: 'Manufacturer / Brand',
    osfilter: 'Operating System',
    showall: 'Show all',
    search: 'Search'
  },
  'es-ud': {
    title: 'Seleccionar Producto',
    soon: '¡Disponible Próximamente!',
    brandfilter: 'Fabricante / Marca',
    osfilter: 'Sistema Operativo',
    showall: 'Mostrar todo',
    search: 'Buscar'
  },
  es: {
    title: 'Seleccionar Producto',
    soon: '¡Disponible Próximamente!',
    brandfilter: 'Fabricante / Marca',
    osfilter: 'Sistema Operativo',
    showall: 'Mostrar todo',
    search: 'Buscar'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/DeviceSelectModal/messages.js